import React from 'react';

import { fetcher } from '@weezevent/weezjs-core';
import { useInterval } from '../../../components/export/exportButton';

export const useFetchStatistics = ({ route, queryParams = {}, onStats = () => {}, onError = () => {}, disabled = false }) => {
    const updateDelay = 60000;
    const noStatsDelay = 5000;

    const [delay, setDelay] = React.useState(1);
    const [stats, setStats] = React.useState(null);

    const call = React.useCallback(() => {
        setDelay(updateDelay);
        fetcher
            .get(route, {
                query: queryParams,
                cache: false
            })
            .then(({ response: stats }) => {
                if (stats.some(s => s.last_computed === null)) {
                    // If any stats are null, set delay to minimum value
                    setDelay(noStatsDelay);
                }

                setStats(stats);
                onStats(stats);
            })
            .catch(e => {
                if (e.code === 403) {
                    setDelay(null);
                } else {
                    onError();
                }
            });
    }, [route, queryParams, onStats, onError]);

    if (!disabled) {
        useInterval(call, delay);
    }

    return stats;
};
